export function hide_site_header() {
      let doc = document.documentElement;
      let w = window;
      let prevScroll = w.scrollY || doc.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;
      let header = document.getElementById('site-header');
      let checkScroll = function() {
        if (window.outerWidth < 1024) {
          curScroll = w.scrollY || doc.scrollTop;
          if (curScroll > prevScroll) {
            direction = 2;
          }
          else if (curScroll < prevScroll) {
            direction = 1;
          }
          if (direction !== prevDirection) {
            toggleHeader(direction, curScroll);
          }
          prevScroll = curScroll;
        }
      };
      let toggleHeader = function(direction, curScroll) {
        if (direction === 2 && curScroll > 90) {
          header.classList.add('hide');
          prevDirection = direction;
        }
        else if (direction === 1) {

          header.classList.remove('hide');
          prevDirection = direction;
        }
      };
      window.addEventListener('scroll', checkScroll);
    }

export function important_notice() {
  if($('#notice-close-btn').length) {
    $('#notice-close-btn').click(()=> {
      $('.important-notice').addClass('hide');
      let now = new Date();
      let time = now.getTime();
      time += 3600 * 3000;
      now.setTime(time);
      document.cookie = `important_notice=${true}; path=/; expires=${now.toUTCString()}`;
    });
  }
}

export function submenu_btn() {
    $('.menu-item-has-children').each(function() {
        $('> a', this).append('<div class="submenu-btn">&nbsp;</div>');
    });
    $('.submenu-btn').click(function(e) {
      e.preventDefault();
      $(this).closest('.menu-item-has-children').toggleClass('open-submenu');
    });
  }

export function remove_navigation_class() {
  if (window.innerWidth > 960) {
      $('.navigation').removeClass('open');
    }
}

export function sticky_scroll() {
  if ($('.navigation').length > 0) {
  var scroll = $(window).scrollTop();
  var navigation_offset = $('.navigation').offset().top + $('.navigation').outerHeight();
  if (scroll > navigation_offset) {
    $('.sticky-navigation-wrap').addClass('show');
  } else {
    $('.sticky-navigation-wrap').removeClass('show');
  }
}
}

export function left_or_right_menu() {
  $('.main-menu .container >.menu-item-has-children >.sub-menu >.menu-item-has-children').hover(function() {
    if(!$(this).hasClass('hover')) {
      let parent_height = $(this).parent().outerHeight();
      let height = $('>.sub-menu', this).outerHeight();
      $(this).addClass('hover');
      $('>.sub-menu', this).css({display: 'block', visibility: 'hidden'});
      if(height < parent_height) {
        $('>.sub-menu', this).height(parent_height);
      }
      let window_width = $(window).width();
      let element_position = $('>.sub-menu', this).offset().left;
      let element_width = $('>.sub-menu', this).width();
      if(window_width < (element_position + element_width)) {
        $(this).addClass('menu-to-the-left');
      }
      $('>.sub-menu', this).css({visibility: 'visible'});
    }
  }, function() {
    $(this).removeClass('hover menu-to-the-left');
    $('>.sub-menu', this).css({display: '', visibility: ''});
  });
}
